import React from 'react';
import { Stethoscope, ListOrdered, FlaskConical, Lightbulb, Rocket } from 'lucide-react';

const steps = [
  {
    icon: Stethoscope,
    title: 'Diagnose',
    body: 'We review the current funnel, campaigns, store presence, tracking, and monetization model.',
  },
  {
    icon: ListOrdered,
    title: 'Prioritize',
    body: 'We identify the highest-impact growth bottlenecks and rank opportunities by effort, confidence, and commercial upside.',
  },
  {
    icon: FlaskConical,
    title: 'Test',
    body: 'We launch focused tests across channels, creative, store-page messaging, onboarding, or revenue flows.',
  },
  {
    icon: Lightbulb,
    title: 'Learn',
    body: 'We connect performance data to business outcomes, not just campaign metrics.',
  },
  {
    icon: Rocket,
    title: 'Scale',
    body: 'We increase investment behind what works and reduce waste around what does not.',
  },
];

const Process = () => {
  return (
    <section
      data-testid="app-growth-process"
      className="py-24 px-4 sm:px-6 lg:px-8 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold uppercase tracking-wider mb-4">
            How we work
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight tracking-tight">
            A calm, structured process.
          </h2>
        </div>

        <div className="relative">
          {/* Horizontal line for desktop */}
          <div className="hidden lg:block absolute left-0 right-0 top-8 h-0.5 bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div
                  key={i}
                  data-testid={`process-step-${i}`}
                  className="relative bg-white border border-gray-100 rounded-2xl p-6 hover:shadow-lg transition-shadow"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="relative z-10 w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center text-white shadow-md">
                      <Icon size={24} />
                    </div>
                    <div className="text-4xl font-bold text-gray-200">0{i + 1}</div>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">{s.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{s.body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
